import React, { useState } from "react"
import { Col, Row, Card, Tag } from "antd"
import styles from "./style.module.css"
import { Route } from "react-router-dom"
import WhatsappSvg from "./svgs/WhatsappSvg"
import WhatsappQrcode from "assets/images/channels/qr-code.png"
import { isAldeia } from "hooks/useAldeia"
import ChannelCard from "./ChannelCard"
import { channelsDef } from "./channels.def"
import AddWhatsappCloud from "./whatsappCloud/AddWhatsappCloud"
import AddWhatsApp from "./whatsapp/AddWhatsApp"
import { QrCodeIcon } from "components-old/icons"
// import AddWhatsappEmbedded from "./whatsapp/embed/AddWhatsappEmbedded"
import { useStore } from "hooks"
import { session } from "store"

// interface IChannelType {
//   ComponentSVG?: any
//   name?: string
//   to?: string
//   logoType?: "image"
//   imgStyle?: any
//   disabled?: boolean
//   oficial?: boolean
//   onClick?: Function
// }

// const LinkButton = ({ children, ...props }: any) => <a {...props}>{children}</a>

function AddChannelWhatsapp() {
  const { user, workspace } = useStore(session)

  // const channelsTypes: IChannelType[] = [
  //   {
  //     ComponentSVG: WhatsappSvg,
  //     name: "WhatsApp Cloud API",
  //     // onClick: () => {
  //     //     setVisibleModal(true)
  //     // },
  //     to: "/settings/channels/new/whatsapp-cloud-api",
  //     oficial: true,
  //     // disabled: !user.isSystemAdmin,
  //   },
  //   ...(isStaging
  //     ? [
  //         {
  //           ComponentSVG: WhatsappSvg,
  //           name: "WhatsApp Oficial",
  //           // onClick: () => {
  //           //     setVisibleModal(true)
  //           // },
  //           to: "/settings/channels/new/whatsapp-embedded",
  //           oficial: true,
  //           // disabled: !user.isSystemAdmin,
  //         },
  //       ]
  //     : []),
  //   ...(user.email !== "facebook_test//botar_o_endereco_eletronico_google_teste_aqui"
  //     ? ([
  //         {
  //           ComponentSVG: WhatsappQrcode,
  //           logoType: "image",
  //           imgStyle: { width: 55, height: 55 },
  //           name: "WhatsApp App",
  //           to: "/settings/channels/new/whatsapp",
  //         },
  //       ] as any)
  //     : []),
  // ]

  const zapDef = channelsDef.record["whatsapp"]

  return (
    <>
      <Row
        gutter={15}
        wrap={false}
        className="aldeia:grid aldeia:grid-cols-[repeat(auto-fit,_minmax(160px,_200px))] aldeia:gap-2 aldeia:px-2"
      >
        <ChannelCard
          // to={workspace.id == 4807 ? "/settings/channels/new/whatsapp/cloud" : "/settings/channels/new/whatsapp/embedded"}
          to={"/settings/channels/new/whatsapp/embedded"}
          icon={isAldeia ? <div className="size-11">{zapDef?.icon}</div> : <WhatsappSvg />}
          name={isAldeia ? "API Oficial" : "WhatsApp Cloud API"}
          index={0}
          // style={{ height: 160 }}
        />
        {user?.email !== "facebook_test@gmail.com" && (
          <>
            {/* <ChannelCard
              to={"/settings/channels/new/whatsapp/cloud"}
              icon={isAldeia ? <div className="size-11">{zapDef?.icon}</div> : <WhatsappSvg />}
              name={isAldeia ? "Modo Oficial" : "WhatsApp Cloud API"}
              index={0}
            /> */}
            <ChannelCard
              to={"/settings/channels/new/whatsapp/web"}
              // style={{ height: 160 }}
              icon={
                !isAldeia ? (
                  <img src={WhatsappQrcode} alt="" style={{ width: 55, height: 55 }} />
                ) : (
                  <QrCodeIcon className="w-12" />
                  // <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" viewBox="0 0 512 512" className="w-12">
                  //   <g>
                  //     <path
                  //       d="M153.845 187.588v4.406a5.972 5.972 0 0 0 5.972 5.972h20.723a5.971 5.971 0 0 1 5.971 5.971V241.5a5.971 5.971 0 0 1-5.971 5.971h-20.691a5.971 5.971 0 0 0-5.971 5.971v4.287a5.971 5.971 0 0 0 5.971 5.972h36.061a5.972 5.972 0 0 0 5.972-5.972v-70.141a5.972 5.972 0 0 0-5.972-5.972h-36.093a5.972 5.972 0 0 0-5.972 5.972zm16.262-42.7v-9.516a3.5 3.5 0 0 0-3.5-3.5h-25.934a3.5 3.5 0 0 1-3.5-3.5v-25.7a3.5 3.5 0 0 0-3.5-3.5h-9.527a3.5 3.5 0 0 0-3.5 3.5v25.838a3.5 3.5 0 0 1-3.5 3.5h-9.179a3.5 3.5 0 0 0-3.5 3.5v25.768a3.5 3.5 0 0 0 3.5 3.5h9.353a3.5 3.5 0 0 0 3.5-3.5v-9.222a3.5 3.5 0 0 1 3.5-3.5h25.832a3.5 3.5 0 0 1 3.5 3.5v9.178a3.5 3.5 0 0 0 3.5 3.5h25.92a3.5 3.5 0 0 0 3.5-3.5V151.9a3.5 3.5 0 0 0-3.5-3.5h-9.462a3.5 3.5 0 0 1-3.503-3.508zm-.032-117.58v-5.083a5.582 5.582 0 0 0-5.582-5.582h-5.022a5.582 5.582 0 0 0-5.582 5.582V44.01a5.582 5.582 0 0 0 5.582 5.582H181.2a5.582 5.582 0 0 1 5.582 5.582v5.055a5.582 5.582 0 0 0 5.582 5.582h5.349a5.582 5.582 0 0 0 5.582-5.582v-5.24a5.582 5.582 0 0 1 5.582-5.582h5.109a5.582 5.582 0 0 0 5.582-5.582v-5.348a5.582 5.582 0 0 0-5.582-5.582h-38.33a5.583 5.583 0 0 1-5.581-5.583zM153.9 102.394v9.429a3.5 3.5 0 0 0 3.5 3.5h40.975a3.5 3.5 0 0 0 3.5-3.5v-9.429a3.5 3.5 0 0 0-3.5-3.5H157.4a3.5 3.5 0 0 0-3.5 3.5zm0-30.729v5.011a5.583 5.583 0 0 0 5.583 5.582h5.011a5.582 5.582 0 0 0 5.582-5.582v-5.011a5.582 5.582 0 0 0-5.582-5.582h-5.011a5.583 5.583 0 0 0-5.583 5.582zm-65.986 30.947v9.146a3.5 3.5 0 0 0 3.5 3.5h9.19a3.5 3.5 0 0 0 3.5-3.5v-9.146a3.5 3.5 0 0 0-3.5-3.5h-9.19a3.5 3.5 0 0 0-3.5 3.5zm65.909 117.914v4.222a5.971 5.971 0 0 0 5.972 5.971h4.319a5.971 5.971 0 0 0 5.972-5.971v-4.222a5.971 5.971 0 0 0-5.972-5.971h-4.319a5.971 5.971 0 0 0-5.972 5.971zM54.759 5.582v71.3a5.582 5.582 0 0 0 5.582 5.582h71.3a5.582 5.582 0 0 0 5.582-5.582v-71.3A5.582 5.582 0 0 0 131.642 0h-71.3a5.582 5.582 0 0 0-5.583 5.582zm60.25 60.185H77.017a5.582 5.582 0 0 1-5.582-5.582v-38a5.582 5.582 0 0 1 5.582-5.585h37.992a5.582 5.582 0 0 1 5.582 5.582v38a5.582 5.582 0 0 1-5.582 5.585zM236.179 5.582v50.84A5.583 5.583 0 0 0 241.762 62h5.511a5.582 5.582 0 0 0 5.582-5.582V22.193a5.583 5.583 0 0 1 5.582-5.583h37.993a5.583 5.583 0 0 1 5.582 5.583v34.229A5.582 5.582 0 0 0 307.594 62h5.468a5.582 5.582 0 0 0 5.582-5.582V5.582A5.582 5.582 0 0 0 313.062 0h-71.3a5.583 5.583 0 0 0-5.583 5.582zM54.759 187.392v70.533a5.971 5.971 0 0 0 5.971 5.975h70.348a5.972 5.972 0 0 0 5.972-5.972v-70.536a5.971 5.971 0 0 0-5.972-5.971H60.73a5.971 5.971 0 0 0-5.971 5.971zm59.883 59.872H77.428a5.971 5.971 0 0 1-5.972-5.971v-37.225a5.972 5.972 0 0 1 5.972-5.972h37.214a5.971 5.971 0 0 1 5.971 5.972v37.225a5.971 5.971 0 0 1-5.971 5.971zM58.262 98.959h9.452a3.5 3.5 0 0 1 3.5 3.5v25.914a3.5 3.5 0 0 0 3.5 3.5h9.331a3.5 3.5 0 0 1 3.5 3.5v9.527a3.5 3.5 0 0 1-3.5 3.5h-9.23a3.5 3.5 0 0 0-3.5 3.5v9.517a3.5 3.5 0 0 1-3.5 3.5h-9.553a3.5 3.5 0 0 1-3.5-3.5v-58.954a3.5 3.5 0 0 1 3.5-3.504z"
                  //       fill="#000000"
                  //       opacity="1"
                  //       data-original="#000000"
                  //     ></path>
                  //     <rect width="32.986" height="16.322" x="186.703" rx="5.582" fill="#000000" opacity="1" data-original="#000000"></rect>
                  //     <path
                  //       d="M201.882 187.588v70.141a5.972 5.972 0 0 1-5.972 5.972h-36.061a5.971 5.971 0 0 1-5.971-5.972v-4.287a5.971 5.971 0 0 1 5.971-5.971h20.691a5.971 5.971 0 0 0 5.971-5.971v-37.563a5.971 5.971 0 0 0-5.971-5.971h-20.723a5.972 5.972 0 0 1-5.972-5.972v-4.406a5.972 5.972 0 0 1 5.972-5.972h36.093a5.972 5.972 0 0 1 5.972 5.972zM153.652 161.241v-9.176a3.5 3.5 0 0 0-3.5-3.5h-25.84a3.5 3.5 0 0 0-3.5 3.5v9.215a3.5 3.5 0 0 1-3.5 3.5h-9.357a3.5 3.5 0 0 1-3.5-3.5v-25.766a3.5 3.5 0 0 1 3.5-3.5h9.188a3.5 3.5 0 0 0 3.5-3.5v-25.85a3.5 3.5 0 0 1 3.5-3.5h9.525a3.5 3.5 0 0 1 3.5 3.5v25.7a3.5 3.5 0 0 0 3.5 3.5H166.6a3.5 3.5 0 0 1 3.5 3.5v9.536a3.5 3.5 0 0 0 3.5 3.5h9.461a3.5 3.5 0 0 1 3.5 3.5v9.338a3.5 3.5 0 0 1-3.5 3.5h-25.906a3.5 3.5 0 0 1-3.503-3.497zM219.568 38.48v5.346a5.582 5.582 0 0 1-5.582 5.582h-5.1a5.582 5.582 0 0 0-5.586 5.582v5.237a5.582 5.582 0 0 1-5.582 5.582h-5.354a5.583 5.583 0 0 1-5.583-5.582v-5.048A5.583 5.583 0 0 0 181.2 49.6h-21.729a5.583 5.583 0 0 1-5.583-5.582V22.222a5.583 5.583 0 0 1 5.583-5.582h5.019a5.582 5.582 0 0 1 5.582 5.582v5.094a5.582 5.582 0 0 0 5.582 5.582h38.332a5.582 5.582 0 0 1 5.582 5.582z"
                  //       fill="#000000"
                  //       opacity="1"
                  //       data-original="#000000"
                  //     ></path>
                  //     <rect
                  //       width="47.982"
                  //       height="16.437"
                  //       x="153.899"
                  //       y="98.89"
                  //       rx="3.504"
                  //       fill="#000000"
                  //       opacity="1"
                  //       data-original="#000000"
                  //     ></rect>
                  //     <rect
                  //       width="16.172"
                  //       height="16.174"
                  //       x="153.9"
                  //       y="66.086"
                  //       rx="5.582"
                  //       fill="#000000"
                  //       opacity="1"
                  //       data-original="#000000"
                  //     ></rect>
                  //     <rect
                  //       width="16.203"
                  //       height="16.157"
                  //       x="87.912"
                  //       y="99.104"
                  //       rx="3.504"
                  //       fill="#000000"
                  //       opacity="1"
                  //       data-original="#000000"
                  //     ></rect>
                  //     <rect
                  //       width="16.264"
                  //       height="16.158"
                  //       x="153.823"
                  //       y="214.557"
                  //       rx="5.971"
                  //       fill="#000000"
                  //       opacity="1"
                  //       data-original="#000000"
                  //     ></rect>
                  //     <path
                  //       d="M87.871 38.673v5.076a5.582 5.582 0 0 0 5.582 5.582h5.022a5.582 5.582 0 0 0 5.582-5.582v-5.076a5.583 5.583 0 0 0-5.582-5.583h-5.022a5.583 5.583 0 0 0-5.582 5.583z"
                  //       fill="#000000"
                  //       opacity="1"
                  //       data-original="#000000"
                  //     ></path>
                  //     <rect
                  //       width="16.186"
                  //       height="16.232"
                  //       x="87.875"
                  //       y="33.094"
                  //       rx="5.582"
                  //       fill="#000000"
                  //       opacity="1"
                  //       data-original="#000000"
                  //     ></rect>
                  //     <rect
                  //       width="16.181"
                  //       height="16.174"
                  //       x="269.347"
                  //       y="33.104"
                  //       rx="5.582"
                  //       fill="#000000"
                  //       opacity="1"
                  //       data-original="#000000"
                  //     ></rect>
                  //     <rect
                  //       width="16.264"
                  //       height="16.081"
                  //       x="87.918"
                  //       y="214.627"
                  //       rx="5.971"
                  //       fill="#000000"
                  //       opacity="1"
                  //       data-original="#000000"
                  //     ></rect>
                  //     <path
                  //       d="M424.162 84.5H260.25a33.079 33.079 0 0 0-33.08 33.08v361.34A33.08 33.08 0 0 0 260.25 512h163.912a33.081 33.081 0 0 0 33.08-33.08V117.581a33.08 33.08 0 0 0-33.08-33.081zM352.52 490.939h-20.627a8 8 0 0 1 0-16h20.627a8 8 0 0 1 0 16zm32.164-365.664h-84.956a8 8 0 0 1 0-16h84.956a8 8 0 0 1 0 16z"
                  //       fill="#000000"
                  //       opacity="1"
                  //       data-original="#000000"
                  //     ></path>
                  //   </g>
                  // </svg>
                )
              }
              name={isAldeia ? "Modo QRCode" : "WhatsApp App"}
              index={2}
            />
          </>
        )}
        {/* {channelsTypes.map((channelType, index) => {
          const LinkOrButton = channelType.to ? Link : LinkButton

          if (isAldeia) {
            return (
              <ChannelCard
                key={channelType.name || ""}
                to={channelType.to || ""}
                icon={
                  isAldeia ? (
                    <>
                      <div className="size-11">{def?.icon}</div>
                    </>
                  ) : (
                    <>
                      {channelType.logoType == "image" ? (
                        <img src={channelType.ComponentSVG} alt="" style={channelType.imgStyle} />
                      ) : (
                        <channelType.ComponentSVG />
                      )}
                    </>
                  )
                }
                name={channelType.name || ""}
                index={index}
              />
            )
          }

          return (
            <LinkOrButton
              to={channelType.to || ""}
              style={{ margin: 5, width: 190, height: 125 }}
              className={cx({
                [styles.disabled_card]: channelType.disabled,
              })}
              onClick={channelType.onClick}
              key={channelType.name}
            >
              <Card className={styles.channel_card}>
                {channelType.logoType == "image" ? (
                  <img src={channelType.ComponentSVG} alt="" style={channelType.imgStyle} />
                ) : (
                  <channelType.ComponentSVG />
                )}
                <Row
                  justify="center"
                  align="middle"
                  style={{
                    // height: 70,
                    fontSize: 16,
                    fontWeight: 400,
                  }}
                >
                  {channelType.name}
                </Row>
                {channelType.oficial && (
                  <Tag
                    style={{
                      // backgroundColor: "rgba(37,207,67,.1)",
                      // color: "#01221d",
                      backgroundColor: "rgb(76 175 80)",
                      color: "white",
                      fontWeight: 700,
                      padding: "0 20px",
                      marginTop: 3,
                      fontSize: 10,
                      lineHeight: "16px",
                      border: "none",
                      position: "absolute",
                      top: 11,
                      left: -17,
                      transform: "rotateZ(-45deg)",
                    }}
                  >
                    OFICIAL
                  </Tag>
                )}
              </Card>
            </LinkOrButton>
          )
        })} */}
      </Row>
      <Route path={`/settings/channels/new/whatsapp/cloud`} render={() => <AddWhatsappCloud />} />
      <Route path={`/settings/channels/new/whatsapp/web`} render={() => <AddWhatsApp />} />
      {/* <Route path={`/settings/channels/new/whatsapp/embedded`} render={() => <AddWhatsappEmbedded />} /> */}
    </>
  )
}

export default AddChannelWhatsapp
